import type React from 'react'

import Popup from '@/components/map/popup'

import { popup } from './maplibre-popup.css'

type Props = React.PropsWithChildren & {
  latitude: number
  longitude: number
  closeOnMove?: boolean
  onClose?: () => void
}
const MaplibrePopup: React.FC<Props> = ({
  latitude,
  longitude,
  children,
  closeOnMove,
  onClose
}) => {
  return (
    <Popup
      latitude={latitude}
      longitude={longitude}
      closeOnMove={closeOnMove}
      onClose={onClose}
      className={popup}
      maxWidth="240px"
    >
      {children}
    </Popup>
  )
}
export default MaplibrePopup
